<template>
  <div>
    <NavBar />
    <new-unit-of-measurement @created="getUnitsOfMeasurement" />
    <b-container fluid>
      <b-row align-v="center">
        <b-col><h1 class="m-0">UNIDADES DE MEDIDA</h1></b-col>
        <b-col cols="auto">
          <v-btn
            class="v-primary mb-1"
            @click="$bvModal.show('new_unit_of_measurement')"
          >
            <span class="fa fa-plus mr-1"></span> NOVO
          </v-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-data-table
            dense
            :headers="headers"
            :items="unitsOfMeasurement"
            :search="search"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template #[`item.size`]="{ item }">
              {{ item.type.base }} = {{ item.multiple }} {{ item.abbreviation }}
            </template>
          </v-data-table>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
    </b-container>
  </div>
</template>

<script>
import api from "../services/api";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import NewUnitOfMeasurement from "../templates/RestHome/UnitsOfMeasurement/new-unit-of-measurement.vue";

export default {
  name: "UnitsOfMeasurement",

  components: {
    NavBar,
    ErrorsMessages,
    NewUnitOfMeasurement,
  },

  data() {
    return {
      errors: [],
      loading: false,

      search: "",
      headers: [
        { text: "NOME", value: "name" },
        { text: "ABREVIAÇÃO", value: "abbreviation" },
        { text: "QUANTIDADE", value: "size" },
        { text: "TIPO", value: "type.name" },
      ],

      stock_item_units_of_measurement: [],
      typesOfMeasure: [],
    };
  },

  created() {
    this.getUnitsOfMeasurement();
    this.getTypesOfMeasure();
  },

  computed: {
    unitsOfMeasurement() {
      return this.stock_item_units_of_measurement.map((unit) => ({
        ...unit,
        type: this.typesOfMeasure.find(
          (t) => t.id === unit.stock_item_type_of_measure_id
        ),
      }));
    },
  },

  methods: {
    async getUnitsOfMeasurement() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/stock/items/units-of-measurement"
        );
        const { error, errors, stock_item_units_of_measurement } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.stock_item_units_of_measurement =
            stock_item_units_of_measurement;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getTypesOfMeasure() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/stock/items/units-of-measurement/types"
        );
        const { error, errors, typesOfMeasure } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfMeasure = typesOfMeasure;
          console.log(typesOfMeasure);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>